export function preventUpDownDefault(event) {
  if (!event.shiftKey && (event.keyCode === 38 || event.keyCode === 40)) {
    event.preventDefault();
  }
}

export default {
  preventUpDownDefault
};
